import type { AppRouteConfig } from '../types';

export const authRoutes: AppRouteConfig[] = [
  {
    path: '/',
    layout: 'EmptyLayout',
    children: [
      { path: 'login', element: 'SignInPage', index: false },
      { path: 'create-account', element: 'CreateAccountPage', index: false },
      {
        path: 'activate-account',
        element: 'ActivateAccountPage',
        index: false
      },
      {
        path: 'onboarding',
        element: 'CompanyOwnerOnboardingPage',
        index: false,
        requiresAuth: true
      },
      { path: 'set-password', element: 'SetPasswordPage', index: false },
      { path: 'terms', element: 'TermsPage', index: false },
      { path: 'privacy', element: 'PrivacyPage', index: false },
      { path: 'cookies', element: 'CookiesPage', index: false },
      { path: '404', element: 'NotFound', index: false },
      { path: '*', element: 'NotFound', index: false }
    ]
  }
];
